module.exports = __webpack_public_path__ + "static/media/davis.8230336e.png";